import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useWishlist } from "@/context/WishlistContext";
import ProductCard from "@/components/ProductCard";

export default function Wishlist() {
  const { user, loading } = useAuth();
  const { ids } = useWishlist();
  const [products, setProducts] = useState(null);

  useEffect(() => {
    document.title = "Your Chambers — Ram Shack";
    if (!user) return;
    api
      .get("/wishlist")
      .then((r) => setProducts(r.data.products))
      .catch(() => setProducts([]));
  }, [user, ids]);

  if (loading) {
    return <div className="px-6 py-32 text-muted-bone text-center">Loading…</div>;
  }

  if (!user) {
    return (
      <div data-testid="wishlist-signin-prompt" className="px-6 py-32 text-center">
        <div className="overline mb-4">Your Chambers</div>
        <h1 className="font-serif-display text-4xl text-bone mb-6">Saved pieces live behind the door.</h1>
        <p className="text-muted-bone mb-8">Sign in to keep the things you covet.</p>
        <Link
          to="/auth"
          className="inline-block px-10 py-4 uppercase text-xs tracking-[0.22em] text-bone"
          style={{ background: "var(--rs-oxblood)" }}
        >
          Sign in
        </Link>
      </div>
    );
  }

  return (
    <div data-testid="wishlist-page" className="px-6 md:px-12 lg:px-16 py-16 md:py-24">
      <div className="overline mb-4">Saved for later</div>
      <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-bone mb-16 leading-tight">
        Your Chambers.
      </h1>

      {products === null && <div className="text-muted-bone">Loading…</div>}

      {products?.length === 0 && (
        <div
          className="border p-16 text-center"
          style={{ background: "var(--rs-surface)", borderColor: "var(--rs-border)" }}
        >
          <p className="text-muted-bone mb-6">Nothing saved yet. The heart icon keeps things here.</p>
          <Link to="/shop" className="overline" data-testid="wishlist-browse-link">
            Browse the collection →
          </Link>
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {products?.map((p) => (
          <ProductCard key={p.product_id} product={p} />
        ))}
      </div>
    </div>
  );
}
